// TSS vite/02 — centralized constants.
// Variants are generated offline (see docs/images.md); these widths must
// match the files that exist in public/images/.

export const IMAGE_BASE_PATH = '/images';

export const IMAGE_WIDTHS = {
    DEFAULT: [480, 800, 1200],
    HERO:    [640, 960, 1280],
};

export const IMAGE_FORMATS = ['avif', 'webp'];

// Shared by the hero <picture> and the prerendered <link rel="preload">;
// if they differ the browser downloads the hero image twice.
export const HERO_IMAGE_SIZES = '(min-width: 1024px) 500px, (min-width: 640px) 70vw, 92vw';
